import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors";

export function SparkSessionsHero() {
  return (
    <section data-testid="spark-hero-section" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[47px] sm:pt-[61px] lg:pt-[74px] pb-[38px] md:pb-[55px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 items-center">

          {/* LEFT: copy — clean light background, never touches the photo */}
          <div className="lg:col-span-7 lg:pr-12 xl:pr-16 reveal">
            <h1
              data-testid="spark-hero-headline"
              className="font-display text-[36px] sm:text-[48px] lg:text-[58px] leading-[1.08] tracking-tight text-[#1C1917]"
            >
              Bring Whatever Needs Your Attention.
            </h1>
            <div className="mt-5 space-y-1 text-lg md:text-xl leading-relaxed text-[#57534E]">
              <p>Sometimes the next step isn&rsquo;t bigger.</p>
              <p>It&rsquo;s simply the next one.</p>
            </div>
            <p className="mt-5 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-lg">
              Spark Sessions create protected time to stop planning and start making progress on what matters most.
            </p>
            <div className="mt-5 space-y-1 text-lg md:text-xl leading-relaxed text-[#57534E]">
              <p>Bring the project.</p>
              <p>We&rsquo;ll bring the momentum.</p>
            </div>
            <div className="mt-7">
              <a href="mailto:lara@blueprint4joy.com?subject=Spark%20Sessions" data-testid="spark-hero-cta" className={btnPrimary}>
                Join the Next Spark Session
              </a>
            </div>
          </div>

          {/* RIGHT: photo — FeatheredImage, inner (left) edge dissolves into the light bg */}
          <div className="lg:col-span-5 reveal relative mt-8 lg:mt-0">
            <div className="relative aspect-[3/4] lg:aspect-[4/5]">
              <FeatheredImage
                src={`${A}/spark-coffee-shop-laptop.jpg`}
                alt="Lara working quietly at a coffee shop table with her laptop, notebook and coffee nearby."
                objectPosition="55% 8%"
                featherLeft={28}
                testId="spark-hero-image"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
